import * as React from "react";
import { Link } from "react-router-dom";

type S = {
  cookiesAgreement: boolean;
};

export default class Footer extends React.PureComponent<any, S> {
  constructor(props: any) {
    super(props);
    this.state = {
      cookiesAgreement: localStorage.getItem("cookiesAgreement") ? true : false,
    };
  }

  public agreeCookies = () => {
    localStorage.setItem("cookiesAgreement", "true");
    this.setState({ cookiesAgreement: true });
  };

  public render() {
    return (
      <footer className={this.props.popupVisible ? "footer blurred" : "footer"}>
        {!this.state.cookiesAgreement && (
          <div className="cookies">
            <div className="left">
              <p>
                Korzystając z naszych usług, przyjmują Pańśtwo do wiadomości, że używamy plików cookie i podobnych technologii do ulepszania i dostosowania treści, analizy ruchu, dostarczania reklam oraz ochrony przed spamem, złośliwym oprogramowaniem i nieuprawnionym dostępem. Więcej klikając <Link to="/cookiesprivacy">tutaj</Link>
              </p>
              <p>
                Mogą Państwo zarządzać swoimi preferencjami reklamowymi dotyczącymi partnerów zarządzanych przez Obligain, klikając <Link to="/privacypolicy">tutaj</Link>
              </p>
            </div>
            <div className="right">
              <button type="button" className="btn btn--search" onClick={this.agreeCookies}>
                Zaakceptuj
              </button>
            </div>
          </div>
        )}
        <div className="footer__inner container">
          <div className="footer__l">
            <h2>
              <Link to="/">
                <img src="/logo.svg" id="footer__logo" alt="Logo stopki obligain" />
              </Link>
            </h2>
            <h2>
              <a href="https://www.firmagodnazaufania.pl/company,58536,reliance-polska-sp-z-o-o" target="_blank" rel="noopener">
                <img src="/firma_godna_zaufania.png" id="footer__brand" width="200px" alt="Logo stopki obligain" />
              </a>
            </h2>
            <h2>
              <a href="https://www.orlyrachunkowosci.pl/profile-181678-reliance-polska-sp-z-o-o" target="_blank" rel="noopener">
                <img src="/orly_rachunkowosci.png" id="footer__brand" width="180px" alt="Logo stopki obligain" style={{ marginTop: "27px" }} />
              </a>
            </h2>
          </div>
          <div className="footer__r">
            <ul className="footer__menu">
              <li>
                <Link to={"/"}>Strona główna</Link>
              </li>
              <li>
                <Link to={"/dashboard"}>{localStorage.getItem("token") ? "Panel użytkownika" : "Logowanie"}</Link>
              </li>
              {/* {!localStorage.getItem('token') && (
                                <li>
                                    <Link to={'/dashboard/login'}>Logowanie</Link>
                                </li>
                            )} */}
              {/* {localStorage.getItem('token') && (
                                <li>
                                    <Link to={'/dashboard'}>Dashboard</Link>
                                </li>
                            )} */}
              <li>
                <Link to="/mission">Misja</Link>
              </li>
              <li>
                <Link to={"/aboutus"}>O Obligain</Link>
              </li>
              <li>
                <Link to="/cooperation">Współpraca</Link>
              </li>
              <li>
                <Link to="/termsandconditions">Regulamin</Link>
              </li>
              <li>
                <Link to="/media-about-us">Media o nas</Link>
              </li>
            </ul>
            <ul className="footer__menu">
              <li>
                <Link to="/returns">Zwroty</Link>
              </li>
              <li>
                <Link to="/complaints">Reklamacje</Link>
              </li>
              <li>
                <Link to="/formofpayments">Formy płatności</Link>
              </li>
              <li>
                <Link to="/execusiontime">Czas realizacji</Link>
              </li>
              <li>
                <Link to="/faq">FAQ</Link>
              </li>
              <li>
                <Link to="/otherterms">Pozostałe regulaminy</Link>
              </li>
              <li>
                <Link to="/for-media">Dla mediów</Link>
              </li>
            </ul>
            <ul className="footer__menu">
              <li>
                <Link to="/contact">Kontakt</Link>
              </li>
              <li>
                <Link to="/career">Kariera</Link>
              </li>
              <li>
                <Link to="/program">Program</Link>
              </li>
              <li>
                <Link to="/vip">VIP Serwis</Link>
              </li>
              {/* <Link to="/subscription"><li>Abonament</li></Link> */}
              <li>
                <Link to="/privacypolicy">Polityka prywatności</Link>
              </li>
              <li>
                <Link to="/cookiesprivacy">Polityka cookies</Link>
              </li>
              <li>
                <Link to="/risk-warnings">Ostrzeżenia o ryzyku</Link>
              </li>
            </ul>
          </div>
        </div>
      </footer>
    );
  }
}

// function mapStateToProps(state: RootState) {
//     return {
//         ...state
//     };
// }
// export default connect(
//     mapStateToProps,
//     null
// )(Footer)



// WEBPACK FOOTER //
// ./src/components/Layout/Footer.tsx